module.exports = __webpack_public_path__ + "img/40_01_006_531.283af3c0.jpg";